module.exports = __webpack_public_path__ + "ClientApp/content/BlockRichResources/How-will-I-know-its-time.jpg";